<template>
  <BaseModalConfirm
    :value="hasSocailAuthEmailError"
    :title="$tc('modalSocialEmailError.title')"
    :text="$tc('modalSocialEmailError.text')"
    image="general/attention.webp"
    image-alt="modalSocialEmailError.title"
    @submit="closeModal"
  >
    <template #controls="{ onSubmit }">
      <UiBtn
        color="gray"
        :text="$t('modalSocialEmailError.btnClose')"
        @click="onSubmit"
      />
    </template>
  </BaseModalConfirm>
</template>

<script>
import BaseModalConfirm from '~/components/Base/Modal/Confirm'

export default {
  name: 'ModalSocialEmailError',
  components: { BaseModalConfirm },
  computed: {
    hasSocailAuthEmailError() {
      return this.$store.getters['user/GET_SOCIAL_AUTH_EMAIL_ERROR']
    },
  },
  methods: {
    closeModal() {
      this.$store.dispatch('user/SOCIAL_AUTH_EMAIL_ERROR', false)
    },
  },
}
</script>
